import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';

import { ChatChannelListContext } from '../../../chat';
import FeedContext from '../FeedContext';
import ChatContext from '../ChatContext';
import ExternalCoachContext from '../ExternalCoachContext';
import MealPlanContext from '../MealPlanContext';

const PrimaryContextsReadyContext = React.createContext();

const PrimaryContextsReadyContextProvider = ({ children }) => {
  const [readyForDeferredContexts, setReadyForDeferredContexts] = useState(false);

  const { isFeedReady } = useContext(FeedContext);
  const { isChatReady } = useContext(ChatContext);
  const { isReady: isExternalCoachReady } = useContext(ExternalCoachContext);
  const { isReady: isChatChannelListReady } = useContext(ChatChannelListContext);
  const { isReady: isMealPlanReady } = useContext(MealPlanContext);

  const arePrimaryContextsReady = useMemo(() => isFeedReady
    && isChatReady
    && isExternalCoachReady
    && isChatChannelListReady
    && isMealPlanReady,
  [
    isFeedReady,
    isChatReady,
    isExternalCoachReady,
    isChatChannelListReady,
    isMealPlanReady,
  ]);

  /**
   * Primary contexts' ready states may change after the initial render. So we need to
   * make sure that the deferred contexts are only initialized once when the primary contexts
   * are ready the first time, and doesn't get re-initialized again.
   */
  useEffect(() => {
    if (arePrimaryContextsReady && !readyForDeferredContexts) {
      setReadyForDeferredContexts(true);
    }
  }, [arePrimaryContextsReady, readyForDeferredContexts]);

  return (
    <PrimaryContextsReadyContext.Provider value={{ readyForDeferredContexts }}>
      {children}
    </PrimaryContextsReadyContext.Provider>
  );
};

PrimaryContextsReadyContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrimaryContextsReadyContext;
export {
  PrimaryContextsReadyContextProvider,
};
